import { useMutation } from '@tanstack/react-query';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { createMIPLoanDefinition } from '@dealstack/frontend/shared/dataExchange/services/mip.service';
import { LoanDefinitionType } from '@dealstack/shared/lib/generated/models/LoanDefinitionType';

export const useCreateLoan = ({ onSuccess }: { onSuccess?: () => void }) => {
	const tMipManage = useTranslationMipManage();

	return useMutation({
		mutationFn: (data: {
			loansDefinitions: Array<{
				type: string;
				name: string;
				mipId: string;
				funderPersonId?: string;
				funderPersonNameToCreate?: string;
			}>;
		}) =>
			createMIPLoanDefinition({
				loansDefinitions: data.loansDefinitions.map((loan) => ({
					type: loan.type as LoanDefinitionType,
					name: loan.name,
					mipId: loan.mipId,
					funderPersonId: loan.funderPersonId,
					funderPersonNameToCreate: loan.funderPersonNameToCreate,
				})),
			}),
		onSuccess: () => {
			showToastV2({
				state: 'success',
				message: tMipManage('root.loans.toast.added_successfully'),
			});
			onSuccess?.();
		},
		onError: () => {
			showToastV2({
				state: 'error',
				message: tMipManage('root.loans.toast.add_failed'),
			});
		},
	});
};
